import { render, staticRenderFns } from "./Ventas-placeholder.vue?vue&type=template&id=f11cff04"
import script from "./Ventas-placeholder.vue?vue&type=script&lang=js"
export * from "./Ventas-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports